import { render, staticRenderFns } from "./NineNav.vue?vue&type=template&id=afaa8700"
import script from "./NineNav.vue?vue&type=script&lang=js"
export * from "./NineNav.vue?vue&type=script&lang=js"
import style0 from "./NineNav.vue?vue&type=style&index=0&id=afaa8700&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports